import styles from './Illustration.module.css';

const Illustration = ({ className = '', ...props }) => (
  <svg
    viewBox="0 0 1001 555"
    fill="none"
    className={`${styles.root} ${className}`.trim()}
    {...props}
  >
    <g className={styles.bg}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 166.012L0 224.316L57.5314 259.208L57.5314 200.904L0 166.012Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.0224609 224.309L64.115 214.218L121.647 249.109L57.5546 259.201L0.0224609 224.309Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M64.0996 214.214L64.0996 520.1L121.631 554.992L121.631 249.106L64.0996 214.214Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M64.0938 520.107L120.206 511.272L177.738 546.164L121.626 554.999L64.0938 520.107Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M120.218 511.265L120.218 147.076L177.75 181.968L177.75 546.157L120.218 511.265Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M120.231 147.08L0.0263672 166.006L57.5585 200.897L177.763 181.971L120.231 147.08Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M207.793 497.494L149.433 506.683L206.965 541.575L265.325 532.386L207.793 497.494Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M149.438 506.662L149.438 112.156L206.97 147.048L206.97 541.553L149.438 506.662Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M149.426 112.159L64.1045 125.593L121.637 160.484L206.958 147.051L149.426 112.159Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M64.1016 125.591L64.1016 64.9343L121.633 99.8259L121.633 160.483L64.1016 125.591Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M64.0996 64.9476L207.782 42.325L265.314 77.2165L121.632 99.8391L64.0996 64.9476Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M207.783 42.3064L207.783 497.469L265.315 532.36L265.315 77.1979L207.783 42.3064Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M499.992 296.878C495.798 297.538 473.731 300.858 469.644 301.118L527.176 336.01C531.263 335.749 553.33 332.43 557.524 331.769L499.992 296.878Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M469.64 301.126C462.749 301.612 452.739 302.116 446.308 301.586L503.84 336.478C510.271 337.008 520.281 336.503 527.172 336.018L469.64 301.126Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M446.293 301.592C439.032 300.71 432.216 299.135 429.134 297.862L486.665 332.753C489.748 334.026 496.564 335.601 503.824 336.483L446.293 301.592Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M429.152 297.849C426.351 296.715 423.666 295.367 421.115 293.821L478.647 328.712C481.198 330.259 483.882 331.606 486.683 332.74L429.152 297.849Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M421.105 293.809C404.032 283.459 392.929 264.199 392.929 240.468L450.461 275.36C450.461 299.09 461.564 318.35 478.637 328.701L421.105 293.809Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M392.949 240.47C392.949 200.809 423.874 163.806 462.069 157.793L519.601 192.684C481.406 198.698 450.481 235.7 450.481 275.361L392.949 240.47Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M462.051 157.803C477.011 155.448 490.85 158.215 502.149 164.84L559.681 199.732C548.382 193.107 534.543 190.339 519.583 192.695L462.051 157.803Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M502.149 164.841C519.098 174.778 530.331 193.393 531.059 216.414L588.591 251.305C587.864 228.284 576.63 209.669 559.682 199.732L502.149 164.841Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M531.067 216.415L586.788 207.642L644.32 242.533L588.6 251.307L531.067 216.415Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M586.778 207.647C586.085 166.133 566.534 132.361 536.611 113.852L594.143 148.744C624.067 167.253 643.617 201.025 644.31 242.538L586.778 207.647Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M536.599 113.845C515.805 100.983 490.002 95.4913 462.038 99.8942L519.57 134.786C547.534 130.383 573.337 135.874 594.131 148.737L536.599 113.845Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M462.061 99.9133C393.097 110.772 337.188 177.672 337.188 249.278L394.72 284.169C394.72 212.564 450.629 145.663 519.593 134.805L462.061 99.9133Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M337.184 249.263C337.184 291.707 356.841 326.208 387.193 345.043L444.725 379.935C414.373 361.099 394.716 326.598 394.716 284.154L337.184 249.263Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M387.195 345.049C392.977 348.637 399.146 351.656 405.642 354.054L463.173 388.945C456.677 386.548 450.508 383.528 444.727 379.941L387.195 345.049Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M405.64 354.052C411.874 356.872 423.642 359.015 426.992 359.392L484.523 394.283C481.173 393.907 469.405 391.764 463.171 388.943L405.64 354.052Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M426.98 359.379C438.429 360.723 453.829 360.424 466.312 359.43L523.844 394.322C511.361 395.316 495.961 395.615 484.513 394.271L426.98 359.379Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M466.332 359.442C470.98 359.098 493.576 355.718 498.357 354.994L555.889 389.885C551.109 390.609 528.513 393.99 523.864 394.334L466.332 359.442Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M498.362 354.989V355.044L555.894 389.936V389.88L498.362 354.989Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M498.344 355.052L942.473 285.124L1000.01 320.016L555.876 389.944L498.344 355.052Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M942.485 285.12V227.215L1000.02 262.107V320.011L942.485 285.12Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M942.48 227.212L499.991 296.882L557.523 331.773L1000.01 262.104L942.48 227.212Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M466.319 396.377C448.975 397.914 428.916 397.954 413.142 395.647L470.674 430.539C486.449 432.846 506.507 432.806 523.851 431.268L466.319 396.377Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M413.147 395.661C410.188 395.239 397.94 392.518 394.813 391.517L452.345 426.408C455.471 427.409 467.719 430.131 470.679 430.553L413.147 395.661Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M394.811 391.512C385.464 388.479 376.598 384.466 368.32 379.564L425.852 414.456C434.13 419.358 442.996 423.371 452.343 426.404L394.811 391.512Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M368.311 379.572C327.896 355.639 301.499 310.523 301.499 254.891L359.031 289.782C359.031 345.415 385.428 390.53 425.843 414.463L368.311 379.572Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M301.523 254.875C301.523 162.931 373.533 76.7631 462.07 62.823L519.602 97.7145C431.065 111.655 359.056 197.823 359.056 289.767L301.523 254.875Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M462.058 62.8357C497.156 57.3095 529.656 63.9636 556.097 79.7424L613.629 114.634C587.188 98.8551 554.688 92.201 519.59 97.7272L462.058 62.8357Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M556.101 79.7249C595.763 103.393 621.795 147.592 622.522 202.009L680.054 236.9C679.327 182.483 653.295 138.285 613.633 114.616L556.101 79.7249Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M622.504 202.024L680.495 192.893L738.027 227.785L680.036 236.915L622.504 202.024Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M680.515 192.891C679.807 119.794 645.569 60.1547 593.023 27.4102L650.556 62.3017C703.101 95.0462 737.339 154.685 738.048 227.782L680.515 192.891Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M593.02 27.4047C556.505 4.65 511.149 -5.11725 462.061 2.61176L519.593 37.5033C568.682 29.7743 614.037 39.5415 650.552 62.2962L593.02 27.4047Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M462.064 2.61646C341.588 21.5853 243.563 138.859 243.563 264.007L301.095 298.899C301.095 173.751 399.121 56.4768 519.596 37.508L462.064 2.61646Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M243.554 264.01C243.554 338.243 278.085 398.711 331.269 431.756L388.801 466.647C335.618 433.603 301.086 373.134 301.086 298.902L243.554 264.01Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M331.28 431.744C339.938 437.123 349.09 441.776 358.668 445.643L416.2 480.534C406.622 476.667 397.47 472.015 388.812 466.635L331.28 431.744Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M358.655 445.648C371.006 450.484 388.737 454.702 394.746 455.625L452.278 490.517C446.269 489.593 428.538 485.376 416.187 480.539L358.655 445.648Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M394.755 455.628C414.263 458.633 438.158 458.856 459.483 457.202L517.015 492.093C495.69 493.747 471.795 493.525 452.287 490.519L394.755 455.628Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M459.48 457.201C466.713 456.617 491.954 452.948 499.335 451.814L556.867 486.705C549.486 487.84 524.245 491.509 517.013 492.093L459.48 457.201Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M499.336 451.81L942.482 382.037L1000.01 416.928L556.868 486.701L499.336 451.81Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M942.464 382.044V321.981L999.995 356.873V416.936L942.464 382.044Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M942.473 321.994L499.984 391.663L557.517 426.555L1000.01 356.885L942.473 321.994Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M499.999 391.651C494.7 392.485 471.521 395.957 466.333 396.386L523.865 431.277C529.053 430.848 552.232 427.376 557.531 426.542L499.999 391.651Z"
      />
      <path
        className={styles.accent}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M57.5449 200.888L57.5449 259.192L121.637 249.101L121.637 554.986L177.749 546.151L177.749 181.962L57.5449 200.888ZM265.319 532.363L206.959 541.552L206.959 147.046L121.637 160.48V99.8234L265.319 77.2007L265.319 532.363ZM557.518 331.763C553.324 332.423 531.256 335.743 527.169 336.003C520.278 336.489 510.268 336.993 503.837 336.463C496.576 335.581 489.76 334.006 486.678 332.733C465.134 324.011 450.465 302.641 450.465 275.364C450.465 235.703 481.389 198.701 519.584 192.687C556.984 186.798 587.379 212.929 588.591 251.297L644.312 242.524C643.137 172.162 587.789 124.039 519.584 134.778C450.621 145.636 394.711 212.537 394.711 284.143C394.711 334.671 422.57 373.942 463.168 388.928C469.402 391.748 481.17 393.891 484.52 394.268C495.968 395.612 511.368 395.313 523.851 394.319C528.5 393.975 551.096 390.595 555.877 389.87V389.926L1000.01 319.998V262.093L557.518 331.763ZM523.851 431.262C506.508 432.8 486.449 432.839 470.674 430.533C467.714 430.111 455.466 427.389 452.34 426.388C397.356 408.547 359.038 356.787 359.038 289.759C359.038 197.815 431.047 111.647 519.584 97.7071C607.33 83.8915 678.833 146.203 680.045 236.898L738.036 227.767C736.836 103.874 639.313 18.6424 519.584 37.4936C399.109 56.4624 301.083 173.737 301.083 298.884C301.083 385.202 347.773 452.908 416.185 480.529C428.536 485.365 446.267 489.583 452.276 490.507C471.784 493.512 495.679 493.735 517.005 492.081C524.237 491.497 549.478 487.828 556.86 486.694L1000.01 416.92V356.857L557.518 426.527C552.219 427.361 529.039 430.833 523.851 431.262Z"
      />
    </g>
  </svg>
);

export default Illustration;
